import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Header, Nav, HamburgerMenu, BtnDelete } from './components'

import { 
    loginUserCheck, 
    logoutUser,
    catalogFetch,
    catalogDeleteById
} from '../redux/actions'

class AdminCatalog extends Component {

    constructor(){
        super()
        this.state = {
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
        this.props.catalogFetch()
    }

    _handleLogout() {
        this.props.logoutUser()
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _onDeleteItem(id, file) {
        if(window.confirm('Are you sure you want to delete this item?')) {
            let oldfile = decodeURIComponent(file.substring(70,97))
            this.props.catalogDeleteById(id, oldfile)
        }
    }

    showCatalog() {
        if(this.props.catalogs) {
            return this.props.catalogs.map((item,index) => {
                let d = new Date(item.catalog_id)
                const date = d.getDate()+"/"+(d.getMonth()+1)+"/"+d.getFullYear()
                return (
                    <tr key={++index}>
                        <td>{index}</td>
                        <td>{item.title}</td>
                        <td>{item.file}</td>
                        <td>{date}</td>
                        <td>{item.created_by}</td>
                        <td>
                            <BtnDelete click={() => this._onDeleteItem(item.id, item.file)}/>
                        </td>
                    </tr>
                )
            })
        }
    }

    render() { 
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-catalog">
                    <Nav active="catalog"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>แคตตาล็อก</h2>
                                <div className="btn-addbrand">
                                    <Link to="/admin/addcatalog" className="add-brand">เพิ่มแคตตาล็อก</Link>
                                </div>
                            </div>
                            <div className="info">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>File (URL)</th>
                                            <th>Created Date</th>
                                            <th>Created By</th>
                                            <th>Delete Catalog</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.showCatalog()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, catalog }) => {
    return { 
        user: auth.user,
        catalogs: catalog.catalogs
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, catalogFetch, catalogDeleteById
})(AdminCatalog)